import { render, staticRenderFns } from "./appraisalOrganSetupList.vue?vue&type=template&id=3fa30e8a"
import script from "./appraisalOrganSetupList.vue?vue&type=script&lang=js"
export * from "./appraisalOrganSetupList.vue?vue&type=script&lang=js"
import style0 from "./appraisalOrganSetupList.vue?vue&type=style&index=0&id=3fa30e8a&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports